import React, { SVGAttributes } from "react";

// KOA-5857 — Local table-editor toolbar glyphs.
// The shared small-icons upload/download assets are 24px black fixed-color
// drawings. These icons are 16px, outline-only, and inherit currentColor so
// they match KuikaButton's neutral/disabled states.

export const ImportRowsIcon: React.FC<SVGAttributes<SVGSVGElement>> = (
  props: SVGAttributes<SVGSVGElement>
): JSX.Element => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8 2.5V9.25" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    <path
      d="M5.25 6.75L8 9.5L10.75 6.75"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 10.5V12.75C3 13.1642 3.33579 13.5 3.75 13.5H12.25C12.6642 13.5 13 13.1642 13 12.75V10.5"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ExportRowsIcon: React.FC<SVGAttributes<SVGSVGElement>> = (
  props: SVGAttributes<SVGSVGElement>
): JSX.Element => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8 10V3.25" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    <path
      d="M5.25 5.75L8 3L10.75 5.75"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 10.5V12.75C3 13.1642 3.33579 13.5 3.75 13.5H12.25C12.6642 13.5 13 13.1642 13 12.75V10.5"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ReloadRowsIcon: React.FC<SVGAttributes<SVGSVGElement>> = (
  props: SVGAttributes<SVGSVGElement>
): JSX.Element => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M19.933 13.041a8 8 0 1 1 -9.925 -8.788c3.899 -1 7.935 1.007 9.425 4.747"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M20 4v5h-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Three vertical column shapes — used by the "Columns" picker button in
// the toolbar. Same 16-px outline style as the import / export / reload
// glyphs so the toolbar reads as one set.
export const ColumnsIcon: React.FC<SVGAttributes<SVGSVGElement>> = (
  props: SVGAttributes<SVGSVGElement>
): JSX.Element => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="2.5" y="3" width="2.5" height="10" rx="0.5" stroke="currentColor" strokeWidth="1.4" />
    <rect x="6.75" y="3" width="2.5" height="10" rx="0.5" stroke="currentColor" strokeWidth="1.4" />
    <rect x="11" y="3" width="2.5" height="10" rx="0.5" stroke="currentColor" strokeWidth="1.4" />
  </svg>
);

// Counter-clockwise arc with a left-pointing arrow head — the standard
// "undo" glyph. Mirror is the "redo".
export const UndoIcon: React.FC<SVGAttributes<SVGSVGElement>> = (props: SVGAttributes<SVGSVGElement>): JSX.Element => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3 6.5h7a3.5 3.5 0 0 1 0 7H6"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5.5 4 3 6.5 5.5 9" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const RedoIcon: React.FC<SVGAttributes<SVGSVGElement>> = (props: SVGAttributes<SVGSVGElement>): JSX.Element => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13 6.5H6a3.5 3.5 0 0 0 0 7h4"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 4 13 6.5 10.5 9"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
